/**
 * A/B bucket for pages with an active experiment. The bucket lives in the `ab_bucket` cookie, which the site
 * writes only after cookie consent (persistBucket.ts); Fastly forwards a valid value as `X-AB-Bucket` and the
 * origin only reads it. No header means the visitor has no bucket (no consent yet, or a crawler): they get the
 * original and aren't counted. A page that renders an experiment must send `Vary: X-AB-Bucket` so Fastly caches
 * one copy per bucket (and one for "no bucket"). The origin never sets the cookie — a Set-Cookie here would land
 * on a cached, shared response.
 */
import type { IncomingMessage, ServerResponse } from 'node:http';

export type Bucket = 'treatment' | 'control';

export function bucketForExperiment(req: IncomingMessage, res: ServerResponse): Bucket | null {
  res.appendHeader('Vary', 'X-AB-Bucket');
  return readBucket(req);
}

export function readBucket(req: IncomingMessage): Bucket | null {
  const value = req.headers['x-ab-bucket'];
  return isBucket(value) ? value : null;
}

export function isBucket(value: unknown): value is Bucket {
  return value === 'treatment' || value === 'control';
}
